export default __webpack_public_path__ + "static/media/Blackmarrow Boots.1f6e0b1d.jpg";